import classnames from 'classnames/bind'
import React from 'react'

import SliderArrow from '../SliderArrow'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export type SliderArrowsProps = {
  buttonClassName?: string
  prevSlide: () => void
  nextSlide: () => void
  layout?: 'inside' | 'outside'
}

function SliderArrows({
  prevSlide,
  nextSlide,
  layout,
  buttonClassName,
}: SliderArrowsProps) {
  return (
    <>
      <SliderArrow
        onClick={prevSlide}
        className={cx(css.sliderArrow, css.leftArrow, buttonClassName, {
          [layout]: layout,
        })}
      />
      <SliderArrow
        onClick={nextSlide}
        className={cx(css.sliderArrow, css.rightArrow, buttonClassName, {
          [layout]: layout,
        })}
      />
    </>
  )
}

SliderArrows.defaultProps = {}

export default SliderArrows
